import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

@Pipe({name: 'safe'})
export class SafePipe implements PipeTransform {
  constructor(private readonly domSanitizer: DomSanitizer) {
  }

  transform(url: any) {
    // TODO - this is a hack to get around the fact that without a potential xss breach the sanitizer is not working. Fix it properly.
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url)
  }
}
